(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbb-amazon-prime"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function toast(msg){
    var t = document.querySelector('.mbb-toast');
    if(!t){ t = document.createElement('div'); t.className='mbb-toast'; document.body.appendChild(t); }
    t.innerHTML = msg + ' <a href="'+root+'cart">View cart</a>';
    requestAnimationFrame(function(){ t.classList.add('show'); });
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('show'); }, 3500);
  }
  function refreshCount(){
    fetch(root + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('mbb:cart:updated', {detail:c}));
      }).catch(function(){});
  }
  function openDrawer(){
    var d = document.querySelector('cart-drawer');
    if(d && typeof d.open === 'function'){ try{ d.open(); return true; }catch(e){} }
    return false;
  }
  document.addEventListener('submit', function(e){
    var form = e.target.closest('.mbb-quickadd');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('button'); var orig = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.innerHTML = 'Adding'; }
    fetch(root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
    })
    .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
    .then(function(){ refreshCount(); if(!openDrawer()){ toast('Added to cart'); } })
    .catch(function(){ window.location.href = root + 'cart'; })
    .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = orig; } });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbb-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function toast(msg){
    var t = document.querySelector('.mbb-toast');
    if(!t){ t = document.createElement('div'); t.className='mbb-toast'; document.body.appendChild(t); }
    t.innerHTML = msg + ' <a href="'+root+'cart">View cart</a>';
    requestAnimationFrame(function(){ t.classList.add('show'); });
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('show'); }, 3500);
  }
  function refreshCount(){
    fetch(root + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('mbb:cart:updated', {detail:c}));
      }).catch(function(){});
  }
  function openDrawer(){
    var d = document.querySelector('cart-drawer');
    if(d && typeof d.open === 'function'){ try{ d.open(); return true; }catch(e){} }
    return false;
  }
  document.addEventListener('submit', function(e){
    var form = e.target.closest('.mbb-quickadd');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('button'); var orig = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.innerHTML = 'Adding'; }
    fetch(root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
    })
    .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
    .then(function(){ refreshCount(); if(!openDrawer()){ toast('Added to cart'); } })
    .catch(function(){ window.location.href = root + 'cart'; })
    .finally(function(){ if(btn){ btn.disabled = false; btn.innerHTML = orig; } });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
